import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
var initForm = {
  fromDate: '',
  toDate: ''
};
export default {
  meta: {
    title: '退换货服务分析',
    auth: true,
    authorityValue: "store-statistics-management"
  },
  name: 'service',
  data: function data() {
    return {
      form: cloneDeep(initForm),
      newsList: [{
        tit: '退货量',
        key: 'refunds'
      }, {
        tit: '换货量',
        key: 'exchanges'
      }, {
        tit: '退款金额',
        key: 'refundAmount'
      }, {
        tit: '退货率',
        key: 'refundRate'
      }]
    };
  },
  methods: {
    rangeDateChange: function rangeDateChange(e) {
      if (e === null) {
        this.form.fromDate = '';
        this.form.toDate = '';
      } else {
        this.form.fromDate = e[0];
        this.form.toDate = e[1];
      }

      this.dataBind(this.form);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.dataPostSale(item);

              case 2:
                data = _context.sent;

                _this.newsList.forEach(function (v) {
                  return _this.$set(v, 'count', data[v.key] || 0);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.dataBind();
  }
};